export default class LeadershipGrid {
  constructor(elem) {
    this.elem = elem;
    this.cards = this.elem.querySelectorAll('.js-tg-card');
    this.leadershipGridComponents = [...document.querySelectorAll('[data-component="LeadershipGrid"]')];
  }

  handleCardClick() {
    const obj = {
      scrollPos: window.scrollY
    };
    // if this.elem contains --other class it means that it'll be an accordion on mobile
    if (this.elem.classList.contains('leadershipGrid--other')) {
      // store the active accordion queryselector in sessionStorage so that we can open it when we go back to the page
      obj.activeAccordionIndex = parseInt(this.elem.dataset.teamGridIndex);
    }

    sessionStorage.setItem('leadershipGridPersistence', JSON.stringify(obj));
  }

  handlePersistence() {
    const referrer = document.referrer;

    // return early if there's no referrer
    if (!referrer) return;

    const referrerMatch = referrer.match(/people\/leadership\/\w+/);

    // return early if the referrer doesn't match the leadership page
    if (!referrerMatch) return;

    const persistence = JSON.parse(sessionStorage.getItem('leadershipGridPersistence'));

    // return early if there's no persistence data in sessionStorage
    if (!persistence) return;

    // click the accordion with the matching index
    const accordion = document.querySelector(`[data-team-grid-index="${persistence.activeAccordionIndex}"]`);

    if (accordion) {
      const accordionTrigger = accordion.querySelector('.js-accgrid-trigger');
      accordionTrigger.click();
    }

    // scroll to the position
    window.scrollTo(0, persistence.scrollPos);

    // remove the persistence data from sessionStorage
    sessionStorage.removeItem('leadershipGridPersistence');
  }

  init() {
    this.cards.forEach(card => {
      card.addEventListener('click', this.handleCardClick.bind(this));
    });

    // run once on the last TeamGrid component instance
    if (this.leadershipGridComponents.indexOf(this.elem) === this.leadershipGridComponents.length - 1) {
      setTimeout(() => {
        this.handlePersistence();
      }, 100);
    }
  }
}